import React from "react";
import { lazy } from "react";

const PasswordChangedForm = lazy(() => import("../../../Components/Settings/User/Users/PasswordChangedForm"));
const UseContainer = lazy(() => import("../../UserContainer/UserContainer"));

function PasswordChangedFormPage() {
  return (
    <div>
      <UseContainer
        activePage={<PasswordChangedForm />}
        disableTitleBar={true}
        headerTitle={"Password Changed Form"}
        breadCrumb={"Password Changed / Password Changed Form"}
        buttons={[]}
      />
    </div>
  );
}

export default PasswordChangedFormPage;
